"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("../../../theme/styled"));

var emotion_theming_1 = require("emotion-theming");

var styled_system_1 = require("styled-system");

var CardActions = styled_1.default.div(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'flex',
    marginTop: "".concat(theme.space ? theme.space[3] : 0, "px")
  };
}, styled_system_1.space, styled_system_1.layout);
exports.default = emotion_theming_1.withTheme(CardActions);